import {TimelineLite, Power0} from 'gsap';
const CurrentStepArray = require('./current-step-array');
const cerr = window.console.error;

class ScreenSlider extends CurrentStepArray {
    constructor() {
        let collection = Array.from(arguments);
        let params = {};

        if (!(collection[collection.length - 1] instanceof AScreenSlide))  {
            params = collection[collection.length - 1];
        }

        collection = collection.filter(s => s instanceof AScreenSlide);
        super(...collection);
        
        this.config = Object.assign({
            root: undefined,
            loop: false,
            start: true
        }, params);


        this._sizes = new ScreenSlideSizes();

        if (!this.config.start) super.current = null;

        collection.forEach((item, i) => {
            item._addToSlider(this);
            item.index = i;
        });
        
        if ( this._initRoot() ) {

            this._handleResize(null);

            this._appendChildren();
            this._changeTrigger();
            window.addEventListener('resize', this._handleResize.bind(this));
        }
    }
    _initCurrent() {
        let result = super._initCurrent();
        this._stepCallbacks = [];
        this._modeCallbacks = [];
        return result;
    }
    _initRoot() {
        const root = this.config.root;

        if (typeof root !== 'undefined') {
            if (root instanceof HTMLElement) {
                this._root = root;
                return true;
            } else {
                cerr('Passed root is not instance of HTMLElement');
                return false;
            }
        }
    }

    _appendChildren() {
        while (this._root.firstChild) {
            this._root.removeChild(this._root.firstChild);
        }
        let i;
        for (i = 0; i < this._collection.length; i++)
        {
            this._root.appendChild(this._collection[i].render());
        }
    }

    _handleResize() {
        if (!this._sizes.changed) return;

        this._modeCallbacks.forEach(callback => {
            callback.call(this, this._sizes.current.label);
        });

        this.current._modeTrigger(this);
    }

    get mode() {
        return this._sizes.current.label;
    }

    get current() {
        return super.current;
    }
    set current(slide) {
        if (typeof this._root === 'undefined' || super.current === slide) {
            return super.current;
        }

        const step = new ScreenStep(super.current, slide);
        let result = super.current = slide;

        if (result) {
            this._changeTrigger(step);
        }
        return result;
    }
    go(num = 0, blank = false) {
        if (this.config.loop) {
            if (num !== 0) {
                const min = 0;
                const max = this._collection.length - 1;
                
                let result = (this.currentIndex + num) % this._collection.length;
                if (result < 0) {
                    result = this._collection.length + result;
                } else {
                    result = Math.max(min, result);
                    result = Math.min(max, result);
                }

                if (blank) {
                    return this._collection[result];
                }
                return this.current = this._collection[result];
            } else if (blank) {
                return this.current;
            }
        } else {
            return super.go(num, blank);
        }
    }
    removeAll() {
        if (typeof this._root === 'undefined') {
            return false;
        }
        const current = this.current;
        const step = new ScreenStep(current);

        let result = super.removeAll();

        if (current) {
            this._changeTrigger(step);        
        }

        return result;
    }

    goTo(index) {
        if (index instanceof AScreenSlide) {
            return this.goToSlide(index);
        } else if (typeof index === 'number') {
            return this.goToIndex(index);
        }
    }
    goToIndex(index, blank = false) {
        if (this.config.loop) {
            const min = 0;
            const max = this._collection.length - 1;

            let result = index % this._collection.length;

            if (result < 0) {
                result = this._collection.length + result;
            } else {
                result = Math.max(min, result);
                result = Math.min(max, result);
            }

            if (blank) {
                return this._collection[result];
            }
            return super.goToIndex(result, blank);// this.current = this._collection[result];
        } else {
            super.goToIndex(index, blank);
        }
    }
    goToSlide(slide) {
        return this.current = slide;
    }
    _changeTrigger(step) {
        this._stepCallbacks.forEach(callback => {
            callback.call(this, step);
        });
        

        if (step && step.previous) {
            step.previous._hideTrigger();
            this.render();

            if (typeof step.current !== 'undefined') {
                step.current._showTrigger(this);
            }
        } else if (typeof this.current !== 'undefined') {
            this.render();            
            this.current._showTrigger(this);
        }
    }
    on(eventName, callback) {
        const availableEvents = ['step'];

        if (availableEvents.indexOf(eventName) > -1) {
            let method = '_on' + eventName;
            this[method](callback);
        }
    }
    _onstep(callback) {
        this._stepCallbacks.push(callback);
    }
    _onmode(callback) {
        this._modeCallbacks.push(callback);
    }
    render() {
        /*if (typeof this.current !== 'undefined') {
            let element = this.current.render();
            
            while (this._root.firstChild) {
                this._root.removeChild(this._root.firstChild);
            }
            
            this._root.appendChild(element);
*/
            return true;
       /* } else {
            while (this._root.firstChild) {
                this._root.removeChild(this._root.firstChild);
            }

            return false;
        }*/
    }
}


class AScreenSlide {
    constructor() {
        this.callbacks = {};
        this.callbacks.onshow = [];
        this.callbacks.onhide = [];
        this.callbacks.onact = [];
        this.callbacks.onmode = [];
    }
    render() {}
    _addToSlider(slider) {
        if (typeof this._sliders === 'undefined') {
            this._sliders = [];
        }
        this._sliders.push(slider);
    }
    _onshow(callback) {
        this.callbacks.onshow.push(callback);
    }
    _onhide(callback) {
        this.callbacks.onhide.push(callback);
    }
    _onact(callback) {
        this.callbacks.onact.push(callback);
    }
    _onmode(callback) {
        this.callbacks.onmode.push(callback);
    }
    set failSlide(slide) {
        if (slide instanceof AScreenSlide) {
            this._failSlide = slide;
            return true;
        } else {
            cerr('Passed agrument slide is not instance of AScreenSlide');
            return false;
        }
    }
    _onfail() {
        if (typeof this._failSlide !== 'undefined') {
            return this._failSlide._element;
        }
    }
    _showTrigger(slider) {
        this.callbacks.onshow.forEach(callback => {
            callback.call(null, slider);
        });
    }
    _modeTrigger(slider) {
        this.callbacks.onmode.forEach(callback => {
            callback.call(null, slider.mode);
        });
    }
    _hideTrigger() {
        this.callbacks.onhide.forEach(callback => {
            callback.call(null);
        });
    }
    _actTrigger() {
        this.callbacks.onact.forEach(callback => {
            callback.call(null);
        });
    }
    on(eventName, callback) {
        const availableEvents = ['show', 'hide', 'act', 'mode'];

        if (availableEvents.indexOf(eventName) > -1) {
            let method = '_on' + eventName;
            this[method](callback);
        }
    }
}

class ScreenStep {
    constructor(previous, current) {
        this.previous = previous;
        this.current = current;
    }
}

class ScreenSlide extends AScreenSlide {
    constructor(element, name, params = {}) {
        super();
        if (element instanceof HTMLElement) {
            this._element = element;
            let element2 = element.querySelector('.windowsPopup');
            this._popup = element2 ? new WinPopup(element2) : null;

            if (typeof params === 'object') {
                this._params = params;
            } else {
                cerr('Passed argument params is not type of object');                
            }
        } else {
            cerr('Passed argument element is not instance of HTMLElement');
        }

        this._name = name;
    }
    activate(b) {
        if (!this._popup) return;
        if (b)
            this._popup.on(this._actTrigger.bind(this));
        else
            this._popup.off();
    }
    act() {
        this._popup.playAct();
    }
    render() {
        return this._element;
    }
}

class WinPopup {
    constructor(element) {
        if (element instanceof HTMLElement) {
            this._element = element;
        } else {
            cerr('Passed argument element is not instance of HTMLElement');
        }
    }
    on(callback) {
        if (this._on) return;
        this._on = true;
        this._callback = callback;

        this._element.classList.remove('active');

        this._layers = [...this._element.querySelectorAll('.windowsPopup__layer')];
        this._tl = new TimelineLite();

        this._tl.set(this._layers[0], {xPercent:-28, yPercent: 8, opacity: 0})
            .set(this._layers[1], {xPercent:-22, yPercent: 19, opacity: 0})
            .set(this._layers[2], {xPercent:-15, yPercent: 30, opacity: 0});
        if (this._layers.length === 4) {
            this._tl.set(this._layers[3], {xPercent:-8, yPercent: 41, opacity: 0});
        }
        this._tl.to(this._layers[0], 0.16, {opacity: 1})
            .to(this._layers[1], 0.16, {opacity: 1})
            .to(this._layers[2], 0.16, {opacity: 1});


        this._lr = function () {
            if (typeof this._callback === 'function')
                this._callback.call(this);

            this.playAct();

        }.bind(this);
        this._element.addEventListener('click', this._lr);
    }
    off() {
        this._on = false;
        this._element.classList.remove('active');
        this._element.removeEventListener('click', this._lr);
        delete this._callback;
    }
    playAct() {
        this._tl = new TimelineLite();

        this._element.classList.add('active');

        if (this._layers.length === 4) {
            this._tl.set(this._layers[0], {xPercent:-28, yPercent: 8, opacity: 1})
                .set(this._layers[1], {xPercent:-22, yPercent: 19})
                .set(this._layers[2], {xPercent:-15, yPercent: 30, opacity: 1})
                .set(this._layers[3], {xPercent:-31, yPercent: 0, opacity: 0})
                .to(this._layers[2], 0.2, {ease: Power0.easeInOut, xPercent: -8, yPercent:40, opacity: 0, onComplete: function () {
                    this._element.classList.remove('active');
                }, onCompleteScope: this})
                .to(this._layers[1], 0.2, {ease: Power0.easeInOut, xPercent: -15, yPercent:30}, "-=0.02")
                .to(this._layers[0], 0.2, {ease: Power0.easeInOut, xPercent: -22, yPercent:19}, "-=0.1")
                .to(this._layers[3], 0.2, {ease: Power0.easeInOut, xPercent: -28, yPercent:8, opacity: 1});
        }
    }
}


class ScreenSlideSizes {
    constructor() {
        this._default = {
            label: ''
        }
        this._queue = [
            {
                label: '_MT_P',
                test: (w, h) => {
                    // Mobile and tablet portrait
                    return w <= 768 && h >= w;
                }
            },
            {
                label: '_M_L',
                test: (w, h) => {
                    // Mobile landscape
                    return h <= 425 && h < w;
                }
            }
        ];
    }
    get changed() {
        return this._update();
    }
    get current() {
        return this._current;
    }
    _update() {
        const w = bodyWidth();
        const h = bodyHeight();

        if (this._lastW === w && this._lastH === h) return false;

        let result = this._default;

        for (let i = 0, max = this._queue.length; i < max; i++) {
            if (this._queue[i].test(w, h)) {
                result = this._queue[i];
                break;
            }
        }

        function bodyWidth() {
            let d = document,
                g = d.getElementsByTagName('body')[0];
            return g.offsetWidth;
        }

        function bodyHeight() {
            let d = document,
                g = d.getElementsByTagName('body')[0];
            return g.offsetHeight;
        }

        this._prev = this._current;
        this._current = result;
        this._lastW = w;
        this._lastH = h;
        return this._current !== this._prev;
    }


}






module.exports.ScreenSlider = ScreenSlider;
module.exports.ScreenSlide = ScreenSlide;
module.exports.ScreenSlideSizes = ScreenSlideSizes;


// WEBPACK FOOTER //
// ./js/screen-slider.js